/**
 * Calculate MSIS-29 physical and mental scores and total filled fields
 * @function
 * @param {array<object>} d - List of MSIS documents
 * @return {array<object>}
 *  - Same list, but with 3 new keys containing total filled fields and sums of physical and mental scores
 */
import { forEach, defaultTo } from 'ramda';
import { historySections as sections } from './MSISSections';
import { getLatestCommitData } from 'lib/documentHandling';

const calculateMSISTotals = d => {
  for (let i = 0; i < d.length; i++) {
    d[i] = {
      ...d[i],
      scores: {
        physical: 0,
        mental: 0,
      },
      filled: 0,
    };
    forEach(phys => {
      // Get section value. Map values if content key exists, already mapped in summary
      let value = safelyHandleValue(getLatestCommitData(d[i]), phys);
      if (value) {
        d[i].scores.physical += value;
        d[i].filled++;
      }
    }, sections.physical);
    forEach(mental => {
      let value = safelyHandleValue(getLatestCommitData(d[i]), mental);
      if (value) {
        d[i].scores.mental += value;
        d[i].filled++;
      }
    }, sections.mental);
  }
  return d;
};

const safelyHandleValue = (obj, val) => defaultTo(null, obj[val]);

export default calculateMSISTotals;
